import { DataCapsule, LocalStorageStrategy, WixStorageStrategy } from 'data-capsule';
export class ClientPersistanceService {
    constructor(namespace) {
        try {
            this.isLocalStorage = localStorage;
            this.capsule = new DataCapsule({
                strategy: new LocalStorageStrategy(),
                namespace
            });
        }
        catch (e) { }
    }
    set(key, value = '', options) {
        let returnValue;
        if (this.isLocalStorage) {
            returnValue = this.capsule.setItem(key, value, options);
        }
        return returnValue;
    }
    async get(key) {
        let returnValue;
        if (this.isLocalStorage) {
            try {
                returnValue = await this.capsule.getItem(key);
            }
            catch (error) { }
        }
        return returnValue;
    }
    async removeItem(key) {
        await this.capsule.removeItem(key);
    }
}
export class ClientPersistanceServiceRemote {
    constructor(namespace) {
        try {
            this.capsule = new DataCapsule({
                strategy: new WixStorageStrategy(),
                namespace
            });
        }
        catch (e) { }
    }
    set(key, value = '') {
        const returnValue = this.capsule.setItem(key, value);
        return returnValue;
    }
    async get(key) {
        let returnValue;
        try {
            returnValue = await this.capsule.getItem(key);
        }
        catch (error) { }
        return returnValue;
    }
    async removeItem(key) {
        await this.capsule.removeItem(key);
    }
    getIsDesignerTouchupsOn(brandId) {
        return this.get(`designerTouchups${brandId}`);
    }
    setIsDesignerTouchupsOn(brandId, isOn) {
        return this.set(`designerTouchups${brandId}`, isOn);
    }
}
//# sourceMappingURL=ClientPersistanceService.js.map